import React, { useEffect, useState } from 'react';
import { API } from '../../../App';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
} from '@mui/material';

import Paper from '@mui/material/Paper';

import AddIcon from '@mui/icons-material/Add';
import SponsorsRow from './SponsorsRow';

// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';

function ListSponsors() {
  const [sponsors, setSponsors] = useState([]);
  /**
   *
   * @param {*} event
   * @param {*} newValue
   */
  // const handleSponsorStatus = (event, newValue) => {
  //   console.log('sponsor change, event : ', event, ', newValue : ', newValue);
  // };
  /**
   *
   * @returns
   */
  const getSponsors = async () => {
    const sponsorsResponse = await fetch(`${API}/api/admin/sp/list`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage['tk']}`,
      },
    })
      .then((res) => res.json())
      .catch((err) => console.log(err));
    if (!sponsorsResponse.message) {
      setSponsors(sponsorsResponse);
    } else {
      return (window.location.href = '/admin');
    }
  };

  const deleteSponsor = async (id) => {
    try {
      if (!window.confirm('Seguro desea borrar el registro?')) {
        return false;
      }
      const response = await fetch(`${API}/api/admin/sp/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage['tk']}`,
        },
      }).then((res) => {
        setSponsors([]);
        getSponsors();
      });
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getSponsors();
  }, []);

  return (
    <TableContainer style={{ backgroundColor: '#010b2a' }} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
              Sponsor
            </TableCell>
            <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
              Sitio Web
            </TableCell>
            <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
              Orden
            </TableCell>
            <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
              Estado
            </TableCell>
            <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
              Imagenes
            </TableCell>
            <TableCell
              style={{ color: 'white', fontSize: '1.5rem' }}
            ></TableCell>

            <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
              <Link href='/admin/panel/sponsors/new'>
                <AddIcon color='primary' />
              </Link>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sponsors.map((sponsor) => (
            <SponsorsRow c={sponsor} deleteCallBack={deleteSponsor} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
export default ListSponsors;
